import { IconProps } from './IconProps';

export const ShoppingTrolley = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="30"
      height="27"
      viewBox="0 0 30 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2876_715)">
        <path
          d="M10.1074 20.2734H24.9512C25.3613 20.2734 25.7324 19.9219 25.7324 19.4629C25.7324 18.9941 25.3613 18.6523 24.9512 18.6523H10.3223C9.56055 18.6523 9.08203 18.1445 8.96484 17.334L6.8457 3.01758C6.72852 2.1875 6.42578 1.76758 5.32227 1.76758H0.791016C0.351562 1.76758 0 2.13867 0 2.57812C0 3.01758 0.351562 3.38867 0.791016 3.38867H5.20508L7.27539 17.5684C7.51953 19.2383 8.4082 20.2734 10.1074 20.2734ZM7.8418 15.8105H24.8926C26.6504 15.8105 27.5098 14.7559 27.7637 13.0371L28.7988 6.25C28.8184 6.10352 28.8477 5.89844 28.8477 5.80078C28.8477 5.23438 28.4375 4.86328 27.793 4.86328H6.64062L6.66992 6.48438H27.0215L26.0742 12.8613C25.957 13.6816 25.5371 14.1895 24.7656 14.1895H7.80273L7.8418 15.8105ZM11.2988 26.3574C12.4121 26.3574 13.291 25.4785 13.291 24.3652C13.291 23.252 12.4121 22.373 11.2988 22.373C10.1855 22.373 9.29688 23.252 9.29688 24.3652C9.29688 25.4785 10.1855 26.3574 11.2988 26.3574ZM22.9492 26.3574C24.0625 26.3574 24.9512 25.4785 24.9512 24.3652C24.9512 23.252 24.0625 22.373 22.9492 22.373C21.8359 22.373 20.9375 23.252 20.9375 24.3652C20.9375 25.4785 21.8359 26.3574 22.9492 26.3574Z"
          fill={props.fill ?? '#000000'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2876_715">
          <rect
            width="29.8438"
            height="26.3574"
            fill={props.fill ?? '#000000'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};
